:host {
  display: block;
}

::slotted(ul) {
  list-style-type: none;
}

::slotted(li) {
  padding: 0 25px;
}

ux-input {
  border-left: 0;
  border-right: 0;
  margin-bottom: 10px;
  margin-top: -10px;
}

::slotted(ux-checkbox) {
  background-color: red;
}

::slotted(*) {
  margin-left: 20px;
}

#noContent {
  margin-left: 20px;
  padding: 10px 0;
}